module.exports = __webpack_public_path__ + "static/rcon-0752ac75c6686025b0ea011a634d733b.gif";